import { isDefined } from '@sgme/fp';
import { dateNow } from 'utils/core/now';
import { getNewGuid } from 'utils/guid';
import { getFrontVersion } from 'utils/version';

import type { IHttpConfig } from '../httpClient.model';

export default (config: IHttpConfig): IHttpConfig => {
  const headers: Record<string, string> = {
    ...config.headers,
  };

  if (!isDefined(headers['X-Correlation-ID'])) {
    headers['X-Correlation-ID'] = getNewGuid();
  }

  if (!isDefined(headers['front-version'])) {
    headers['front-version'] = getFrontVersion();
  }

  headers.timestamp = `${dateNow()}`;

  return {
    ...config,
    headers,
  };
};
